import type { SVGProps } from 'react';

const TitleKeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <circle cx="14.5" cy="4.5" r="3" stroke="#2563EB" />
    <path
      d="M11.5 4.5L7.5 12.5M17.5 4.5L21.5 12.5"
      stroke="#2563EB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="0.5" y="12.5" width="28" height="15" rx="4.5" stroke="#112A55" />
  </svg>
);

export default TitleKeyIcon;
